import { passengerTypes as passengerTypeLookup } from 'types/passengers';

const pluralPassengerTypeLookup = {
  adult: 'adultPlural',
  child: 'childPlural',
  infantInArms: 'infantInArmsPlural',
  seatedInfant: 'seatedInfantPlural',
  senior: 'seniorPlural',
  youth: 'youthPlural',
  dog: 'dogPlural'
};

const getPassengerTypeTranslationId = (passengerType, quantity = 1) => {
  const translationKey = passengerTypeLookup[passengerType] || 'adult';
  const pluralTranslationKey = quantity > 1 ? pluralPassengerTypeLookup[translationKey] : null;

  return `passengerTypes.${pluralTranslationKey || translationKey}`;
};

export default getPassengerTypeTranslationId;
